import React from "react";
import { v4 as uuidv4 } from "uuid";
import { Menu, MenuItem, MenuButton, SubMenu } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { PaziaButtonType, btnClasses } from "../PaziaButton/PaziaButton";

export interface PaziaMenuAction {
  name: string | React.ReactNode;
  onClick: () => void;
}
interface MoreActionsMenuProps {
  actions: PaziaMenuAction[];
  children?: React.ReactNode;
  type?: PaziaButtonType;
  disabled?: boolean;
  className?: string;
}
export const MoreActionsMenu = ({
  actions,
  disabled,
  className,
  children,
  type = "tertiary",
}: MoreActionsMenuProps): JSX.Element => {
  return (
    <Menu
      menuButton={
        <MenuButton
          // The default trigger is just three dots: give it an accessible name (also used by e2e specs)
          aria-label={children ? undefined : "Więcej akcji"}
          className={`h-[2.375rem] ${btnClasses[disabled ? "disabled" : type]} ${
            className ?? ""
          }`}
        >
          {children ?? (
            <svg
              className="w-4 h-1 fill-current text-slate-400"
              viewBox="0 0 16 4"
            >
              <circle cx="8" cy="2" r="2" />
              <circle cx="2" cy="2" r="2" />
              <circle cx="14" cy="2" r="2" />
            </svg>
          )}
        </MenuButton>
      }
    >
      {actions.map((action) => (
        <MenuItem key={uuidv4()} onClick={action.onClick}>
          {action.name}
        </MenuItem>
      ))}
    </Menu>
  );
};
